import React, { Component } from 'react'

import Breadcrumbs from '../block/Breadcrumbs'
import Proizvodstvo from '../block/Proizvodstvo'
import Postavki from '../block/Postavki'
import About from '../block/About'
import Stati from '../block/Stati'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Breadcrumbs breadcrumbs={data?.breadcrumbs || []} />
        <Proizvodstvo data={data} />
        <Postavki data={data} hidebtn={true} />
        <About data={data} />
        <Stati data={data} />
      </>
    )
  }
}

export default App